<div class="xcdrs-dialog">
  <div mat-dialog-title class="dialog-header">
    <h1 class="title"> {{'SelectGroup' | translate}}</h1>
    <button mat-button mat-icon-button mat-dialog-close class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <ul class="organizations-list">
      <li class="list-item" *ngFor="let subGroup of subGroups; let first = first; let i = index;">
        <mat-checkbox (change)="onSubGroupsCheckboxChanged($event, group)"
          [checked]="isSubGroupSelected(subGroup.Idenedi)" [value]="subGroup.Idenedi"></mat-checkbox>
        <div class="info">
          <span class="org-name">{{ subGroup.Profile.FirstName }}
            {{ subGroup.Profile.LastName }}</span>
          <span class="org-visibility primary-text">
            <div [ngSwitch]="subGroup.Idenedi">
              <ng-container *ngSwitchCase="'anonymous'">
                <span>{{'AnonymousUserNotPartOfThisGroup' | translate}}</span>
              </ng-container>
              <ng-container *ngSwitchCase="'admins'">
                <span> {{ subGroup.GroupSummary.NumberOfAdmins }}
                  {{'Admin' |translate}}{{
                  subGroup.GroupSummary.NumberOfAdmins > 1 ? "s" : ""
                  }}</span>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <span> {{ subGroup.GroupSummary.NumberOfMembers }}
                  {{'Member' |translate}}{{
                  subGroup.GroupSummary.NumberOfMembers > 1 ? "s" : ""
                  }}</span>
              </ng-container>
            </div>
          </span>
        </div>
      </li>
    </ul>
    <mat-spinner style="margin: 1.5rem auto" *ngIf="loading"></mat-spinner>
  </div>
  <div mat-dialog-actions>
    <div class="d-flex flex-row flex-grow-1">
      <button (click)="closeDialog()" mat-flat-button class="flex-grow-1" color="primary" [disabled]="loading">
        {{'done' | translate}}
      </button>
    </div>
  </div>
</div>
